import { Loader2 } from 'lucide-react';

export default function Load() {
  return (
    <div className='contain-load'>
      <Loader2 size={32} className="animate-spin" />
    </div>
  );
}
